















































































































import { Component, Vue, Emit, Watch, Ref } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import BackofficePreAnestesicoStore from '@/components/Backoffice/Store/BackofficePreAnestesicoStore'
import { TipoUsuarioEnum, TipoEnvioMensagemEnum, CancelarSolicitacaoParam, TipoOrigemEnum, RequestMessage, TipoMensagemEnum } from '@/types/_'
import { timeout } from '@/utils/common'
import { PreAnestesia, IPreAnestesia } from '@/types/implements/PreAnestesia'
import EventBus from '@/plugins/EventBus'

@Component
export default class ComponentModalRealizarAvaliacao extends Vue {
  $refs!: { backofficeDadosAnestesia: any }

  tipoAutorizacaoAnexo: any = {
    pedidoMedico: true,
    laudo: true,
    cotacaoOpme: true,
    laudoAnestesista: true,
    anexoOperadora: true,
    resumo: true,
  }

  modalCancelamento: boolean = false
  loadClose: boolean = false
  loadCancelamento: boolean = false
  loadRealizarAvaliacao: boolean = false
  preAnestesia: IPreAnestesia = new PreAnestesia()

  get loadingClose() {
    return this.loadClose
  }

  set loadingClose(value: boolean) {
    this.loadClose = value
  }

  get showModalCancelamento() {
    return this.modalCancelamento
  }

  set showModalCancelamento(value: boolean) {
    this.modalCancelamento = value
  }

  get loadingCancelamento() {
    return this.loadCancelamento
  }

  set loadingCancelamento(value: boolean) {
    this.loadCancelamento = value
  }

  get loadingRealizarAvaliacao() {
    return this.loadRealizarAvaliacao
  }

  set loadingRealizarAvaliacao(value: boolean) {
    this.loadRealizarAvaliacao = value
  }

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get getBackofficePreAnestesicoStore() {
    return getModule(BackofficePreAnestesicoStore, this.$store)
  }

  get getTipoConfirmacao() {
    return TipoOrigemEnum.PreAnestesia
  }

  get getRequestMessage() {
    return new RequestMessage()
  }

  get showModalRealizarAvaliacao() {
    const show = this.getBackofficeGlobalStore.modal.realizarAvaliacao
    this.toggleHtmlOverflow(show)
    this.scrollToMensagem()
    return show
  }

  set showModalRealizarAvaliacao(value) {
    this.getBackofficeGlobalStore.setModal({ name: 'realizarAvaliacao', value })
  }

  @Watch('showModalRealizarAvaliacao')
  onChangeShowModalRealizarAvaliacao() {
    this.$refs.backofficeDadosAnestesia.$refs.dadosAnestesiaForm.resetValidation()
  }

  async cancelamentoSolicitado() {
    this.loadingCancelamento = true
    const response = await this.getBackofficeGlobalStore.anestesistaSolicitaCancelamento()

    if (response) {
      this.showModalCancelamento = false
      EventBus.$emit('setSnackbar', { show: true, text: 'Solicitação cancelada com sucesso!', icon: 'done', color: '#2E7D32', timeout: 3000 })
      await timeout(3000)
      await this.closeModal()
    } else {
      this.showModalCancelamento = false
      EventBus.$emit('setSnackbar', { show: true, text: 'Houve um erro durante o cancelamento.', icon: 'warning', color: '#C62828' })
    }
    this.loadingCancelamento = false
  }

  toggleHtmlOverflow(isOpen: Boolean) {
    const html = document.querySelector('html')
    const noOverflowClass = 'modal-is-open'

    if (html !== null) {
      html.classList.remove(noOverflowClass)
      if (isOpen) {
        html.classList.toggle(noOverflowClass)
        document.getElementsByClassName('v-dialog')[0].scrollTop = 0
      } else {
        this.goToScroll()
      }
    }
  }

  scrollToMensagem() {
    const ele = document.getElementsByClassName('realizar-avaliacao-scroll')
    if (ele.length > 0) {
      ele[0].scrollTo(0, 0)
    }
  }

  async closeModal() {
    this.loadingClose = true
    this.$refs.backofficeDadosAnestesia.$refs.dadosAnestesiaForm.reset()
    let solicitacaoId = this.getBackofficeGlobalStore.solicitacao.id
    await this.preAnestesia.desbloquearSolicitacao(this.getBackofficeGlobalStore.solicitacao.id)
    await this.getBackofficeGlobalStore.closeModalRealizarAvaliacao()
    this.$refs.backofficeDadosAnestesia.clearReservaDeSangue()
    this.loadingClose = false
    await this.getBackofficePreAnestesicoStore.loadAgendamentosMedicoSearch(solicitacaoId)
    solicitacaoId = ''
  }

  async realizarAvaliacao() {
    if (this.$refs.backofficeDadosAnestesia.$refs.dadosAnestesiaForm.validate()) {
      this.loadingRealizarAvaliacao = true
      const response = await this.getBackofficeGlobalStore.anestesistaFazAvaliacao(this.$user.profile.sub)
      if (response) {
        EventBus.$emit('setSnackbar', { show: true, text: 'Avaliação realizada com sucesso!', icon: 'done', color: '#2E7D32' })
        this.loadingRealizarAvaliacao = false
        await this.closeModal()
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: 'Não foi possível realizar a avaliação pré-anestésica', icon: 'warning', color: '#C62828' })
        this.loadingRealizarAvaliacao = false
      }
    } else {
      // eslint-disable-next-line
      const errors = await this.$refs.backofficeDadosAnestesia.$refs.dadosAnestesiaForm._data.errorBag
      const counter = Object.values(errors).filter(e => e === true).length
      EventBus.$emit('setSnackbar', { show: true, text: `Foram encontrados ${counter} erro(s) no formulário`, icon: 'warning', color: '#C62828' })
    }
    this.loadingRealizarAvaliacao = false
  }

  windowWidth: number = 0
  getWindowWidth() {
    this.windowWidth = document.documentElement.clientWidth
  }

  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.getWindowWidth)
      this.getWindowWidth()
    })
  }

  updated() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.getWindowWidth)
      this.getWindowWidth()
    })
  }

  @Emit('setLoadingRequest')
  setLoadingRequest(status, text) { }

  @Emit('clearLoadingRequest')
  clearLoadingRequest() { }

  @Emit('goToScroll')
  goToScroll() { }
}
